export default __webpack_public_path__ + "static/media/Group 8706_2.c1c0d4be.png";